import { render, staticRenderFns } from "./AppManagementSwiper.vue?vue&type=template&id=d644c350&scoped=true&"
import script from "./AppManagementSwiper.vue?vue&type=script&lang=js&"
export * from "./AppManagementSwiper.vue?vue&type=script&lang=js&"
import style0 from "./AppManagementSwiper.vue?vue&type=style&index=0&id=d644c350&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d644c350",
  null
  
)

export default component.exports